import React, { Component } from 'react';
import { showBlocker, hideBlocker } from '../../actions/blocker';
import { fetchFlightDetails, setSelectedFlight, fetchFlightDocuments } from '../../actions/flight-list';
import { connect } from 'react-redux';
import FlightListTable from '../flight-list/flight-list-table';
import Documents from './documents';
import BriefingSheet from './briefing-sheet';
import queryString from 'query-string';
import './styles.css';

class Flight extends Component {
    constructor(props) {
        super(props);
        this.state = {
            docs: [],
            test: "testing"
        };
        this.id = this.props.match.params.id;
        this.options = queryString.parse(this.props.location.search);
        this.setDocs = this.setDocs.bind(this);
    }

    componentDidMount() {
        if (!this.props.selected || this.id !== this.props.selected.id) {
            this.props.showBlocker();
            this.props.fetchFlightDetails({ id: this.id, ...this.options })
                .done((data, textStatus, jqXHR) => this.props.setSelectedFlight(data))
                .always(this.props.hideBlocker);
        }
    }
   

    setDocs() {
        this.props.showBlocker();
        this.props.fetchFlightDocuments(this.id)
            .done((data, textStatus, jqXHR) => this.setState({ docs: data }))
            .always(this.props.hideBlocker);
    }

    render() {
        return (
            <div id='FlightDetails'>
                <FlightListTable flights={this.props.selected ? [this.props.selected] : []} />
                <ul className='nav nav-tabs nav-justified mt-2'
                    role='tablist'>
                    <li className='nav-item'>
                        <a className='nav-link rounded-0 btn btn-sm active'
                            id='FlightDocumentsTab'
                            data-toggle='tab'
                            href='#FlightDocuments'
                            role='tab'
                            aria-controls='FlightDocuments'
                            aria-selected='true'>Documents</a>
                    </li>
                    <li className='nav-item'>
                        <a className='nav-link rounded-0 btn btn-sm'
                            id='FlightBriefingSheetTab'
                            data-toggle='tab'
                            href='#FlightBriefingSheet'
                            role='tab'
                            aria-controls='FlightBriefingSheet'
                            aria-selected='false'>Pre-Flight Briefing Sheet</a>
                    </li>
                </ul>
                <div className='tab-content mt-2 mx-3'>
                    <div className='tab-pane fade show active'
                        id='FlightDocuments'
                        role='tabpanel'
                        aria-labelledby='FlightDocumentsTab'>
                        <Documents
                            data={this.state.docs}
                            id={this.id}
                            setDocs={this.setDocs}
                            options={this.options} />
                    </div>
                    <div className='tab-pane fade'
                        id='FlightBriefingSheet'
                        role='tabpanel'
                        aria-labelledby='FlightBriefingSheetTab'>
                        <BriefingSheet id={this.id} options={this.options} setDocs={this.setDocs} />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    selected: state.flights.selected,
});

const mapActionsToProps = {
    fetchFlightDetails, setSelectedFlight, fetchFlightDocuments,
    showBlocker, hideBlocker,
};

export default connect(mapStateToProps, mapActionsToProps)(Flight);